import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';


import { MENU_TOGGLE_STATE_LANGUAGE } from '../global-navigation.constant';

@Component({
  selector: 'app-global-navigation-spanish',
  templateUrl: './global-navigation-spanish.component.html',
  styleUrls: ['./global-navigation-spanish.components.scss']
})
export class GlobalNavigationSpanishComponent implements OnInit {

  public menuToggleStateLabelSpanish = MENU_TOGGLE_STATE_LANGUAGE.spanish;
  public currentRoute: any;
  public menuExpandCollapse: boolean = true;
  public menuListSpanish: { menuTitle: string, routerLink: string, menuSubTitle?: string, menuIndicator?: number | string, isDisable?: boolean, cssClass: string[] }[] = [
    { menuTitle: 'Tablero de mandos', routerLink: '/dashboard', cssClass: ['icon-lms-dashboard', 'icon-lms-dashboard-fill'] },
    { menuTitle: 'Cursos', routerLink: '/courses', menuSubTitle: 'Gateway A1+', cssClass: ['icon-course', 'icon-course-full'] },
    { menuTitle: 'Clases', routerLink: '/classes', cssClass: ['icon-my-classes', 'icon-my-classes-full'] },
    { menuTitle: 'Calendario', routerLink: '/calendar', cssClass: ['icon-calendar', 'icon-calendar-full'] },
    { menuTitle: 'Productos', routerLink: '/products', cssClass: ['icon-lms-products', 'icon-lms-products-fill'] },
    { menuTitle: 'Usuarias', routerLink: '/users', cssClass: ['icon-lms-users', 'icon-lms-users_fill'] },
    { menuTitle: 'Libro', routerLink: '/book', menuSubTitle: 'Student Book', cssClass: ['icon-book', 'icon-book-full'] },
    { menuTitle: 'Tabla de contenido', routerLink: '/tableofContents', cssClass: ['icon-bookshelf', 'icon-bookshelf_fill'] },
    { menuTitle: 'Desafío', routerLink: '/challenge', menuIndicator: 'Beta', cssClass: ['icon-challenge', 'icon-challenge-full'] },
    { menuTitle: 'Tarea', routerLink: '/homework', cssClass: ['icon-homework', 'icon-homework-full'] },
    { menuTitle: 'Evaluaciones', routerLink: '/assessments', menuIndicator: 'Beta', cssClass: ['icon-lms-assessments', 'icon-assessments-full'] },
    { menuTitle: 'Informes', routerLink: '/reports', cssClass: ['icon-lms-reports', 'icon-lms-reports-fill'] },
    { menuTitle: 'Mensajes', routerLink: '/messages', menuIndicator: 101, cssClass: ['icon-message-dots-circle', 'icon-message-dots-circle-fill'] },
    { menuTitle: 'Notificación', routerLink: '/notification', menuIndicator: 10, isDisable: true, cssClass: ['icon-lms-notification', 'icon-lms-notifications-fill'] },
    { menuTitle: 'Mi perfil', routerLink: '/profile', cssClass: ['icon-profile', 'icon-profile-full'] },
    { menuTitle: 'Ayudar', routerLink: '/help', cssClass: ['icon-help', 'icon-help-full'] },
    { menuTitle: 'Cerrar sesión', routerLink: '/logout', cssClass: ['icon-lms-logout', 'icon-lms-logout-fill'] },
    { menuTitle: 'Más', routerLink: '/more', cssClass: ['icon-dots-vertical', 'icon-more-full'] }
  ];

  constructor(private activatedRoute: ActivatedRoute, private _router: Router) { }

  ngOnInit() {

    this._router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url.split('?')[0];
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params && params['isOpened']) {
        this.menuExpandCollapse = (params['isOpened'] == 'true');
      }
      if (params && params['menuExpandCollapse']) {
        if (params['menuExpandCollapse'] == 'true') {
          this.menuExpandCollapse = false;
        } else {
          this.menuExpandCollapse = true;
        }
      }
    });
  }

}